import React from "react";
import { Modal, Button, Carousel } from "react-bootstrap";

const DocumentModal = ({ show, onHide, images = [] }) => {

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop(); // extract file name
    link.click();
  };

  return (
    <>
<style>
{`
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 16 16'%3E%3Cpath d='M11 1L3 8l8 7'/%3E%3C/svg%3E") !important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 16 16'%3E%3Cpath d='M5 1l8 7-8 7'/%3E%3C/svg%3E") !important;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 2rem !important;
  height: 2rem !important;
  background-size: 100% 100% !important;
}
`}
</style>
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Documents</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {images.length > 0 ? (
          <Carousel interval={null}>
            {images.map((img, index) => (
              <Carousel.Item key={index}>
                <div className="text-center">
                  <img
                    src={img}
                    alt={`Document ${index + 1}`}
                    className="img-fluid"
                    style={{ maxHeight: "70vh", objectFit: "contain" }}
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <p>No documents available.</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        {images.length > 0 && (
          <Button
            variant="success"
            onClick={() => handleDownload(images[0])}
          >
            Download Current Document
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    </> );
};

export default DocumentModal;
